import { Input } from '@profgeosoft-ui/react';
import { useTranslation } from 'react-i18next';

import { wrap } from 'src/packages/mobx-di/wrap';

import type { ChangeEventHandler, MutableRefObject } from 'react';
import type { TFieldRulesData, TFieldView } from 'src/services/directory-service/types';

type Props = {
  fieldView: TFieldView;
  className?: string;
  innerRef?: MutableRefObject<HTMLInputElement | null>;
  error?: string;
  value: string | null;
  fieldRulesData?: TFieldRulesData;
  onChange(fieldId: string, value: unknown): void;
  onBlur?(fieldId: string): void;
};

export const StringInput = wrap<Props>(function StringInput({
  innerRef,
  fieldView,
  error,
  value,
  className,
  fieldRulesData,
  onChange,
  onBlur,
}) {
  const { t } = useTranslation();

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const value = e.target.value;

    onChange(fieldView.fieldId, value === '' ? null : value);
  };

  const onClear = () => {
    onChange(fieldView.fieldId, null);
  };

  const handleBlur = () => {
    onBlur?.(fieldView.fieldId);
  };

  return (
    <Input
      ref={innerRef}
      status={error ? 'error' : undefined}
      className={className}
      value={value}
      loading={fieldRulesData?.isLoading}
      placeholder={t('common:placeholders.enterValue')}
      disabled={fieldRulesData?.isDisabled || fieldRulesData?.isEnteringBlocked}
      onChange={handleChange}
      onClear={onClear}
      onBlur={handleBlur}
    />
  );
});
